module.exports = __webpack_public_path__ + "f8c043593b3730773421874896a502f4.svg";